// extracted by mini-css-extract-plugin
export default {"layout":"layout-module--layout--115d4"};